import { render, staticRenderFns } from "./SidebarBoxNewsletter.vue?vue&type=template&id=00887284&scoped=true&"
import script from "./SidebarBoxNewsletter.vue?vue&type=script&lang=js&"
export * from "./SidebarBoxNewsletter.vue?vue&type=script&lang=js&"
import style0 from "./SidebarBoxNewsletter.vue?vue&type=style&index=0&id=00887284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00887284",
  null
  
)

export default component.exports